import ProcessConfig from './ProcessConfig';

export default class ProcessConfigGroup extends ProcessConfig {
    constructor(data: any) {
        super(data);
        this.maxLength = 5;
    }

    public toServer() {
        return {
            id: this.id,
            title: this.title,
            active: this.active
        };
    }
}
